AuthRoute = require 'mixins/authenticated-route'

App.SettingsOrganizationHostRoute = Em.Route.extend AuthRoute,
  model : ->
    @modelFor('settings.organization')

  renderTemplate: (controller, model) ->
    @render 'settings.organization.host',
      into: 'settings'
